<template>
  <Modal
    v-model="_value"
    width="400"
    title="确认续费服务期"
    @on-visible-change="visibleChange"
    ok-text="确认"
    @on-ok="onOk">
    <Form v-if="orderList.length == 0" ref="renewalOrderForm" :model="renewalOrder" :label-width="100">
      <FormItem prop="serviceDatetime" label="旧服务到期日期">
        <label>{{renewalOrder.oldServiceDatetime?(new Date(renewalOrder.oldServiceDatetime)).Format('yyyy-MM-dd'):'--'}}</label>
      </FormItem>
      <RadioGroup v-model="packageSelectVertical" vertical @on-change="onPackageSelectChange">
        <Radio label="固定套餐时间">
          <span>固定套餐时间</span>
        </Radio>
        <FormItem prop="serviceDatetime" label="选择套餐时间">
          <label>自旧服务期到期日计算</label>
          <br/>
          <Select @on-change="onPackageChooseChange" :disabled="!packageSelect || !renewalOrder.oldServiceDatetime" v-model="packageChoose" size="small" style="width:100px">
            <Option v-for="item in packageList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
          <br/>
          <label v-if="!renewalOrder.oldServiceDatetime">此订单缺少旧服务期</label>
        </FormItem>
        <FormItem v-if="renewalOrder.serviceDatetime && packageSelect" prop="serviceDatetime" label="服务到期日期">
          <label>{{displayPackageChooseDatetime}}</label>
        </FormItem>

        <Radio label="自选时间">
          <span>自选时间</span>
        </Radio>
        <FormItem prop="serviceDatetime" label="服务到期日期">
          <DatePicker :disabled="packageSelect" type="date" style="width: 100%;" v-model="renewalOrder.serviceDatetime"
                      placeholder="选择日期"></DatePicker>
        </FormItem>
      </RadioGroup>

      <FormItem prop="totalAmount" label="总金额">
        <InputNumber :min="0" style="width: 100%;" v-model="renewalOrder.totalAmount"
                     placeholder="请输入总金额">
        </InputNumber>
      </FormItem>
      <FormItem prop="billType" label="开票类型">
        <Select style="width: 100%;" v-model="renewalOrder.billType">
          <Option v-for="item in billType" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="remark" label="备注">
        <Input style="width: 100%;" v-model="renewalOrder.remark"
               type="textarea"
               placeholder="请输入备注"></Input>
      </FormItem>
    </Form>

    <Form v-else ref="renewalOrderForm" :model="orderList">
      <div v-for="item in orderList">
        <FormItem prop="registrationNum" label="车牌号">
          <label style="display: inline-block; width: 100px;">{{item.positioningDeviceInfo.vehicleInfo != null ? item.positioningDeviceInfo.vehicleInfo.registrationNum : item.positioningDeviceInfo.vehicleInfo.vin}}</label>
        </FormItem>
      </div>
<!--      <FormItem prop="serviceDatetime" label="服务到期日期">-->
<!--        <DatePicker type="date" style="width: 100%;" v-model="renewalOrder.serviceDatetime"-->
<!--                    placeholder="选择日期"></DatePicker>-->
<!--      </FormItem>-->

      <RadioGroup v-model="packageSelectVertical" vertical @on-change="onPackageSelectChange">
        <Radio label="固定套餐时间">
          <span>固定套餐时间</span>
        </Radio>
        <FormItem prop="serviceDatetime" label="选择套餐时间">
          <label>自旧服务期到期日计算</label>
          <br/>
          <Select @on-change="onPackageChooseChange" :disabled="!packageSelect || !renewalOrder.oldServiceDatetime" v-model="packageChoose" size="small" style="width:100px">
            <Option v-for="item in packageList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
          <br/>
          <label v-if="!renewalOrder.oldServiceDatetime">此订单缺少旧服务期</label>
        </FormItem>
        <FormItem v-if="renewalOrder.serviceDatetime && packageSelect" prop="serviceDatetime" label="服务到期日期">
          <label>{{displayPackageChooseDatetime}}</label>
        </FormItem>

        <Radio label="自选时间">
          <span>自选时间</span>
        </Radio>
        <FormItem prop="serviceDatetime" label="服务到期日期">
          <DatePicker :disabled="packageSelect" type="date" style="width: 100%;" v-model="renewalOrder.serviceDatetime"
                      placeholder="选择日期"></DatePicker>
        </FormItem>
      </RadioGroup>

      <FormItem prop="totalAmount" label="总金额">
        <InputNumber :min="0" style="width: 100%;" v-model="renewalOrder.totalAmount"
                     placeholder="请输入总金额">
        </InputNumber>
      </FormItem>
      <FormItem prop="billType" label="开票类型">
        <Select style="width: 100%;" v-model="renewalOrder.billType">
          <Option v-for="item in billType" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="remark" label="备注">
        <Input style="width: 100%;" v-model="renewalOrder.remark"
               type="textarea"
               placeholder="请输入备注"></Input>
      </FormItem>
    </Form>

  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'renewalorderconfirmservicedatetimemodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    listValue: null
  },
  data () {
    return {

      packageSelect: true,
      packageChoose: 0,
      packageSelectVertical: '固定套餐时间',
      displayPackageChooseDatetime: '',
      packageList: [
        {
          value: '1',
          label: '一年'
        },
        {
          value: '2',
          label: '二年'
        },
        {
          value: '3',
          label: '三年'
        }
      ],

      //  订单详细
      renewalOrder: {
        id: null,
        totalAmount: 0,
        lastTotalAmount: null,
        oldServiceDatetime: null,
        serviceDatetime: null,
        businessUserId: null,
        businessUser: null,
        receptUserId: null,
        receptUser: null,
        positioningDeviceInfoId: null,
        positioningDeviceInfo: {
          terminalNum: null,
          factoryTerminalNum: null,
          positioningDeviceModel: {

          },
          vehicleInfo: {
            customName: null,
            registrationNum: null,
            registrationColor: null,
            vin: null,
            bodyColor: null,
            vehicleType: {
              id: null,
              name: null
            },
            vehicleBrand: {
              id: null,
              name: null
            },
            engineNum: null,
            vehicleLicenseNum: null,
            unladenMass: null,
            approvedLoad: null,
            vehicleOwnerInfoId: null,
            servicePassword: null,
            vehicleLicenseDistributeDatetime: null,
            vehicleLicenseReigsterDatetime: null,
            remark: null,
            certificateNum: null,
            certificateDistributeDatetime: null,
            vehicleModel: {
              id: null,
              name: null
            },
            chassisModel: null,
            chassisId: null,
            chassisCertificateNum: null,
            engineModel: null,
            energyType: null,
            displacement: null,
            power: null,
            energyUsage: null,
            emissionStandard: null,
            manufacturer: null,
            outlineSizeLong: null,
            outlineSizeWidth: null,
            outlineSizeHeight: null,
            boxSizeLong: null,
            boxSizeWidth: null,
            boxSizeHeight: null,
            springPieceCount: null,
            tyreCount: null,
            tyreSpec: null,
            wheelSpanFront: null,
            wheelSpanBack: null,
            wheelBase: null,
            axisLoad: null,
            axisCount: null,
            turnType: null,
            totalMass: null,
            approvedLoadCoefficient: null,
            towMax: null,
            saddleMax: null,
            cabPeopleCount: null,
            mannedCount: null,
            speedMax: null,
            productionDatetime: null,
            certificateRemark: null,
            vehicleLicensePictureId: null,
            certificatePictureId: null,
            vehicleSrcLicensePicture1Id: null,
            vehicleSrcLicensePicture2Id: null,
            vehicleBodyPictureId: null,
            vehicleUse: null,
            attention: false,
            mliftainsuranceChannelId: null,
            mliftainsurancechannelDatetime: null,
            tiinsuranceChannelId: null,
            tiinsurancechannelDatetime: null,
            insured: null
          }
        },
        updateDatetime: null,
        remark: null,
        billType: 1,
        fileReady: null,
        salesChannelId: null,
        salesChannel: null,
        renewalOrderType: null,
        changeSim: null,
        maintainOrderId: null,
        maintainOrder: null,
        isfree: null,
        needJt808Combine: null,
        renewalNum: null,
        renewalPayOrderId: null,
        renewalPayOrder: null,
        deadlineDatetime: null,
        urgent: '否',
        receptDatetime: '否',
        stepId: null,
        step: {
          orderId: null,
          state: null,
          lastState: null,
          userId: null,
          user: null,
          result: null
        }
      },

      orderList: [],
      orderIds: [],
      orderListstepstate: null,
      orderListstepresult: null,

      billType: [
        { label: '增值税发票', value: 1 },
        { label: '增值税专用发票', value: 2 },
        { label: '增值税普通发票', value: 3 },
        { label: '增值税电子专用发票', value: 4 },
        { label: '增值税电子普通发票', value: 5 }
      ]
    }
  },
  methods: {
    ...mapActions([
      'RenewalOrderServ_ConfirmServiceDatetime'
    ]),
    onOk () {
      if (this.orderList != null && this.orderList.length > 0) {
        store.dispatch('RenewalOrderServ_BatchConfirmServiceDatetime', {
          params:
              {
                orderList: this.orderIds,
                state: this.orderListstepstate,
                result: this.orderListstepresult,
                totalAmount: this.renewalOrder.totalAmount,
                billType: this.renewalOrder.billType,
                serviceDatetime: new Date(this.renewalOrder.serviceDatetime).Format('yyyy-MM-dd hh:mm:ss')
              },
          urlparams: null
        }).then(() => {
          this.$Message.success('确认成功')
          this.$emit('on-success')
        }).catch((err) => {
          this.$Message.error(err)
          this.$emit('on-fail')
        })
      } else {
        if (this.renewalOrder.step != null) {
          this.renewalOrder.step.state == 2
        }
        this.$Modal.confirm({
          title: '提示',
          content: '<p>确认服务期</p>',
          onOk: () => {
            store.dispatch('RenewalOrderServ_ConfirmServiceDatetime',
              { params: this.renewalOrder }).then(() => {
              this.$Message.success('确认成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          },
          onCancel: () => {
          }
        })
      }
    },
    onPackageSelectChange (event) {
      console.log(event)
      if (event == '自选时间') {
        this.packageSelect = false
      } else {
        this.packageSelect = true
        if (this.packageChoose) {
          let d = new Date(this.renewalOrder.oldServiceDatetime)
          console.log('原日期为：' + d)
          let year = d.getFullYear() // 获取年份
          d.setFullYear(year + Number.parseInt(this.packageChoose))
          console.log('加上一年后的日期为：' + d)
          this.renewalOrder.serviceDatetime = d
          this.displayPackageChooseDatetime = this.renewalOrder.serviceDatetime.Format('yyyy-MM-dd')
        }
      }
    },
    onPackageChooseChange (event) {
      console.log(event)
      let d = new Date(this.renewalOrder.oldServiceDatetime)
      console.log('原日期为：' + d)
      let year = d.getFullYear() // 获取年份
      d.setFullYear(year + Number.parseInt(event))
      console.log('加上一年后的日期为：' + d)
      this.renewalOrder.serviceDatetime = d
      this.displayPackageChooseDatetime = this.renewalOrder.serviceDatetime.Format('yyyy-MM-dd')
      //       return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
    },
    visibleChange (val) {
      if (val) {
        this.packageChoose = 0
        this.renewalOrder.serviceDatetime = null
        this.renewalOrder.billType = 1
        this.renewalOrder.receptDatetime = null
        this.renewalOrder.totalAmount = 0
        this.renewalOrder.remark = null

        this.orderList = this._listValue
        this.orderIds = []
        // console.log(this.orderList)
        if (this.orderList != null && this.orderList.length > 0) {
          this.orderList.forEach(item => {
            this.orderIds.push(item.id)
          })
        } else {
          this.orderIds = []

          this.renewalOrder.id = null
          this.renewalOrder.serviceDatetime = null
          this.renewalOrder.billType = 1
          this.renewalOrder.receptDatetime = null
          this.renewalOrder.totalAmount = 0
          this.renewalOrder.remark = null

          let renewalOrderId = this._initValue
          if (renewalOrderId) {
            store.dispatch('RenewalOrderServ_GetDetail', {
              params: { id: renewalOrderId }
            }).then(() => {
              this.renewalOrder = store.getters.get_RenewalOrder_GetDetailResult
              if (this.renewalOrder.serviceDatetime) {
                this.renewalOrder.serviceDatetime = new Date(this.renewalOrder.serviceDatetime)
              }
              this.renewalOrder.remark = null
            }).catch(err => {
              this.$Message.error(err)
            })
          }
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _listValue: {
      get () {
        return this.listValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
